import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Stack, Typography, createTheme, useMediaQuery } from '@mui/material';
import './style.css';
import dayjs from 'dayjs';
import { datetimeFormatter } from '../../utils/datetimeFormatter';

export const ReadOnlyLeadDetails = observer(({ leadDetails }) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const getData = (value) => {
    return value === null ||
      value === undefined ||
      value === '' ||
      (!(typeof value === 'number') && !(value instanceof Date) && value?.trim() === '')
      ? '_'
      : value;
  };

  return (
    <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
      <Stack spacing={4}>
        <Stack spacing={3}>
          <Typography sx={{ fontWeight: '500', alignSelf: 'start' }} component="p">
            Client Information
          </Typography>
          <Grid rowGap={2} container justifyContent={'space-evenly'}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client Name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Email Id
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Requirement
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Lead Source
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Contact Number
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Amount
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Master File
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Site dimension
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Project Value
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Builtup Area
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.customerName)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.emailId)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.requirement)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.leadSource)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.contactNo)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.amount)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.masterLife)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.leadSiteDimension)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.projectValue)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.builtUpArea)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Closing Date
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Stage
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Sub Stage
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Priority
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Probablity For Singup
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Lead Handled by
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client Point Of Contact
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Site Address
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Construction Start TimeLine
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Project Timeline
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Contract Name
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {leadDetails?.closeDate
                      ? datetimeFormatter.formatDate(leadDetails?.closeDate, datetimeFormatter.toLocal)
                      : '_'}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.workFlowStatusName)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.workFlowSubStatusName)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.leadPriority)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.probability)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.leadHandledBy)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.clientPointOfContact)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.siteAddress)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.constructionStartTimeLine)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.projectTimeLine)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.contractName)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
        <Stack spacing={3}>
          <Typography sx={{ fontWeight: '500', alignSelf: 'start' }} component="p">
            Description information
          </Typography>
          <Grid rowGap={2} container justifyContent={'space-evenly'}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Description If any
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.description)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Tag
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(leadDetails?.tags)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Paper>
  );
});
